import { render } from "./MatriculaController.vue?vue&type=template&id=75744f06&scoped=true"
import script from "./MatriculaController.vue?vue&type=script&lang=js"
export * from "./MatriculaController.vue?vue&type=script&lang=js"

import "./MatriculaController.vue?vue&type=style&index=0&id=75744f06&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75744f06"]])

export default __exports__